import Api from './Api'

class Instillinger {
  constructor (type) {
    if (type === 'kunstner') {
      this.base = '/kunstner'
    } else {
      if (type === 'utelagringsdager') {
        this.base = '/instillinger/dayfreestorage'
      } else {
        this.base = '/instillinger/' + type
      }
    }
  }

  index (page) {
    return Api().get(this.base + '.json', {
      params: {
        page: page || 1
      }
    })
  }

  dropdown (key, params = {}) {
    if (key !== null) {
      return Api().get(this.base + '/dropdown.json', {
        params: {
          key: key,
          ...params
        }
      })
    }
  }

  dropdownByParams (params) {
    return Api().get(this.base + '/dropdown.json', {
      params: params
    })
  }

  twentyfourseven () {
    return Api().get(this.base + '/twentyfourseven.json')
  }

  view (id) {
    return Api().get(this.base + '/' + id + '.json')
  }

  save (id, data) {
    if (!id) {
      return Api().post(this.base + '.json', data)
    }

    return Api().put(this.base + '/' + id + '.json', data)
  }

  delete (id) {
    return Api().delete(this.base + '/' + id + '.json')
  }
}

export default type => {
  const instance = new Instillinger(type)

  return instance
}



// WEBPACK FOOTER //
// ./src/services/InstillingerService.js